(function () {
	'use strict';
	angular.module('app.setup')
		.service('dataPipelineColumns', dataPipelineColumns);

	dataPipelineColumns.$inject = ['$rootScope', '$location', 'tableRenderService', 'dataPipelineService', 'siteService', '$experiments'];
	function dataPipelineColumns($rootScope, $location, tableRenderService, dataPipelineService, siteService, $experiments) {
		return [{
			'id': 'factoryNdx',
			'display': 'Site ID',
			'class': '',
			'width': 60,
			'show': false,
			'sort': true,
			'conditional': function () {return $rootScope.authz.isLeanDNAAdmin();}
		}, {
			'id': 'customer',
			'display': 'Customer',
			'class': '',
			'width': 200,
			'show': true,
			'sort': true
		}, {
			'id': 'factory',
			'display': 'Site',
			'class': '',
			'width': 200,
			'renderer': hyperlinkRenderer,
			'show': true,
			'sort': true,
			'leanSync': false
		}, {
			'id': 'type',
			'display': 'Type',
			'class': '',
			'width': 140,
			'renderer': hyperlinkRenderer,
			'show': true,
			'sort': true,
			'leanSync': false,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'action',
			'display': 'Actions',
			'class': '',
			'width': 80,
			'renderer': actionsRenderer,
			'show': true,
			'sort': false,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'status',
			'display': 'State',
			'class': '',
			'width': 120,
			'renderer': stateRenderer,
			'show': true,
			'sort': true
		}, {
			'id': 'statusDetail',
			'display': 'Detail',
			'class': '',
			'width': 450,
			'renderer': statusDetailRenderer,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'statusDetailInternal',
			'display': 'Internal Detail',
			'class': '',
			'width': 450,
			'renderer': statusDetailInternalRenderer,
			'show': true,
			'sort': true,
			'conditional': function () {return $rootScope.authz.isLeanDNAAdmin();}
		}, {
			'id': 'instanceId',
			'display': 'Instance Id',
			'class': '',
			'width': 180,
			'renderer': tableRenderService.title,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'dateRequest',
			'display': 'Requested',
			'class': 'dateCell alignLeft',
			'width': 180,
			'renderer': tableRenderService.dateTime,
			'sortDefaultReverse': true,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'waitTime',
			'display': 'Wait Time',
			'class': 'dateCell alignLeft',
			'width': 80,
			'renderer': durationRenderer,
			'show': true,
			'sort': false,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'dateStart',
			'display': 'Started',
			'class': 'dateCell alignLeft',
			'width': 180,
			'renderer': tableRenderService.dateTime,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'runTime',
			'display': 'Run Time',
			'class': 'dateCell alignLeft',
			'width': 80,
			'renderer': durationRenderer,
			'show': true,
			'sort': false,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'dateEnd',
			'display': 'Ended',
			'class': 'dateCell alignLeft',
			'width': 180,
			'renderer': tableRenderService.dateTime,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'requestor',
			'display': 'Requestor',
			'class': '',
			'width': 180,
			'show': false,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'lastSuccessfulJobDate',
			'display': 'Last successful update',
			'class': 'dateCell alignLeft',
			'width': 80,
			'renderer': tableRenderService.dateTime,
			'show': true,
			'sort': false,
			'conditional': isReadWriteUser
		},		{
			'id': 'dateEndEst',
			'display': 'Estimate Finish',
			'class': 'dateCell alignLeft',
			'width': 180,
			'renderer': tableRenderService.dateTime,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}, {
			'id': 'dateEndStageEst',
			'display': 'Estimate Stage Finish',
			'class': 'dateCell alignLeft',
			'width': 180,
			'renderer': tableRenderService.dateTime,
			'show': true,
			'sort': true,
			'conditional': isRegularAndLeanDNAAdmin
		}];

		function durationRenderer(row, col, rowIndex, params) {
			var startTime = 0;
			var endTime = 0;

			if (col.id === 'waitTime') {
				if(row.type === 'LeanDNA Connect') {
					return '<div class="cell-div"></div>';
				}
				startTime = row.dateRequest;
				endTime = row.dateStart;
			} else if (col.id === 'runTime') {
				startTime = row.dateStart;
				endTime = row.dateEnd;
			}

			if(!startTime || !endTime) {
				return '<div class="cell-div"></div>';
			}

			var duration = endTime - startTime;
			var durationHours = Math.floor(duration / (60 * 60 * 1000)).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
			var durationMinutes = Math.floor(duration / (60 * 1000) % 60).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
			var durationSeconds = Math.floor(duration / 1000 % 60).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
			var formattedDuration = durationHours + ':' + durationMinutes + ':' + durationSeconds;

			return '<div class="cell-div">' + formattedDuration + '</div>';
		}
		
		function getUrlForDataJob(row) {
			var url = '/application/f/home.html#/setup/data-pipeline-job-status?jobId=' + row.jobId;
			url += '&factory=' + row.factory;
			url += '&factoryNdx=' + row.factoryNdx;
			url += '&type=' + row.type;
			return url;
		}

		function hyperlinkRenderer(row, col, rowIndex, params) {
			var linkName = row[col.id] === 'Procurement' ? 'Analytics Engine' : row[col.id];
			var url;
			if (col.id === 'type' && ['LeanSync', 'LeanLoad'].indexOf(row.type) >= 0 && siteService.isAdminForSite(row.factoryNdx)) {
				url = getUrlForDataJob(row);
			} else if (col.id === 'type' && row.type === 'LeanTransform' && row.jobExecutionArn && siteService.isLeanDNAAdminForSite(row.factoryNdx)) {
				url = getUrlForDataJob(row);
			} else if (col.id === 'type' && row.type === 'Procurement' && siteService.isLeanDNAAdminForSite(row.factoryNdx)) {
				url = getUrlForDataJob(row);
			} else if (col.id === 'type' && row.type === 'LeanDNA Connect' && siteService.isLeanDNAAdminForSite(row.factoryNdx)) {
				url = getUrlForDataJob(row);
			} else if (col.id === 'factory' && siteService.isAdminForSite(row.factoryNdx)) {
				url = '/application/f/home.html#/setup/data-pipeline-history?factoryNdx=' + row.factoryNdx;
			}

			var link = url ? '<a href="' + url + '">' + linkName + '</a>' : linkName;
			return '<div class="cell-div" title="' + linkName + '">' + link + '</div>';
		}

		function buildDataPipelineLogLinks(row) {
			var ret = '<pipeline-action-logs';
			ret += ' factoryndx="' + row.factoryNdx;
			ret += '" factory="' + row.factory;
			ret += '" datatype="' + row.type;
			ret += '" daterequest="' + row.dateRequest;
			ret += row.dateStart ? '" datestart="' + row.dateStart : '';
			ret += row.dateEnd ? '" dateend="' + row.dateEnd : '';
			ret += row.instanceId ? '" instanceid="' + row.instanceId : '';
			ret += row.logUrl ? '" logurl="' + row.logUrl : '';
			ret += '" jobid="' + row.jobId;
			ret += '" status="' + row.status;
			ret += '" hass3path="' + row.hasS3Path;
			ret += '" hass3globalfilepath="' + row.hasS3GlobalFilePath;
			ret += row.jobExecutionArn ? '" jobexecutionarn="' + row.jobExecutionArn : '';
			ret += row.pipelineExecutionArn ? '" pipelineexecutionarn="' + row.pipelineExecutionArn : '';
			ret += row.passedHealthChecks ? '" passedhealthchecks="' + row.passedHealthChecks : '';
			ret += '" awsaccountid="' + row.awsAccountId;
			ret += '" awsregion="' + row.awsRegion;
			ret += '"></pipeline-action-logs>';
			return ret;
		}

		function actionsRenderer(row, col, rowIndex, params) {
			var ret = '<div class="cell-div">';
			var isLeanDNAAdmin = $rootScope.authz.isLeanDNAAdmin();
			var showLogs = row.status !== 'WAITING'
				&& (
					isLeanDNAAdmin || (row.type !== 'Procurement' && siteService.isAdminForSite(row.factoryNdx))
				);

			if (showLogs) {
				ret += buildDataPipelineLogLinks(row);
			}

			if (siteService.isAdminForSite(row.factoryNdx)
					&& row.status === 'FAILED' && row.requestor !== 'Pentaho' && row.factoryNdx != 172 && row.factoryNdx != 342) {
				row.isValidationFailure = (row.statusDetail.indexOf('dramatic change') != -1 || row.statusDetail.indexOf('previous input count') != -1);
				if (row.statusDetail.indexOf('Failed health checks') != -1) {
					row.healthCheckFailures = row.statusDetail.substring('Failed health checks'.length);
				}
				if (isLeanDNAAdmin || (row.isValidationFailure || row.healthCheckFailures)) {
					ret += ' <pipeline-step-rerun factory="' + row.factory + '" factoryndx="' + row.factoryNdx + '" isvalidationfailure="' + row.isValidationFailure + '" type="' + row.type + '" jobid="' + row.jobId + '" healthCheckFailures="' + row.healthCheckFailures + '"></pipeline-step-rerun>';
				}
			}
			if (siteService.isLeanDNAUser() && row.passedHealthChecks !== undefined && row.passedHealthChecks !== null) {
				var currentFactoryNdx = ($location.search().factoryNdx !== undefined) ? $location.search().factoryNdx : row.factoryNdx;
				var healthCheckLink = '/application/f/home.html#/setup/data-pipeline-health-check?factoryNdx=' + currentFactoryNdx + '&jobId=' + row.jobId;;
				var healthCheckTrendLink = '/application/f/home.html#/setup/data-pipeline-health-check-trend?factoryNdx=' + currentFactoryNdx;
				ret += '<a class="data-pipline-health-check" title="Show health check report" href="' + healthCheckLink + '"><ng-include src="\'/application/library/ui_images/svg_icons/briefcase-medical-solid.svg\'"></ng-include></a>';
				ret += '<a class="data-pipline-health-check-trend" title="Show health check trend" href="' + healthCheckTrendLink + '"><ng-include src="\'/application/library/ui_images/svg_icons/chart-line-regular.svg\'"></ng-include></a>';
			}
			if (siteService.isAdminForSite(row.factoryNdx)
					&& row.status === 'RUNNING' && row.type !== 'LeanDNA Connect') {
				ret += '<pipeline-step-mark-failed factory="' + row.factory + '" factoryndx="' + row.factoryNdx + '" type="' + row.type + '" jobid="' + row.jobId + '"></pipeline-step-mark-failed>';
			}
			ret += '</div>';
			return ret;
		}
	
		function stateRenderer(row, col, rowIndex, params) {
			var state = row.status;
			var hoverText = undefined;
			if (isReadWriteUser()) {
				if (row.status === 'WAITING' || row.status === 'RUNNING') {
					var columnId = row.status === 'WAITING' ? 'dateRequest': 'dateStart';
					hoverText = 'Started - ' +  tableRenderService.convertDate(row, {},'medium', columnId);
				} else if (row.status === 'FAILED') {
					hoverText = 'Last failure - ' +  tableRenderService.convertDate(row,{}, 'medium', 'dateEnd');
				} else if (row.status === 'SUCCESSFUL') {
					hoverText = 'Last successful data sync - ' +  tableRenderService.convertDate(row, {}, 'medium', 'dateEnd');
				}
			}
			return '<div class="cell-div" title="' + (hoverText || state) + '">' + state + '</div>';
		}
	
		function statusDetailRenderer(row, col, rowIndex, params) {
			var statusDetail = '';
			if (row.status !== undefined && row.status !== null && row.status.indexOf('WAITING') === 0) {
				if (row.statusDetail !== undefined && row.statusDetail !== null && row.statusDetail !== '') {
					statusDetail = row.statusDetail + ' (requested by: ' + row.requestor + ')';
				} else {
					statusDetail = 'Requested by: ' + row.requestor;
				}
			} else {
				statusDetail = row.statusDetail;
			}
			statusDetail = angular.element('<div></div>').text(statusDetail).html();
			return '<div class="cell-div" title="' + statusDetail + '">' + statusDetail + '</div>';
		}

		function statusDetailInternalRenderer(row) {
			var statusDetailInternal = angular.element('<div></div>').text(row.statusDetailInternal).html();
			return '<div class="cell-div" title="' + statusDetailInternal + '">' + statusDetailInternal + '</div>';
		}

		function isRegularAndLeanDNAAdmin() {
			return $rootScope.authz.isLeanDNAAdmin() || siteService.getAdminSitesByCustomer(globalConfig.customer.id).length;
		}

		function isReadWriteUser() {
			return !isRegularAndLeanDNAAdmin();
		}
	};
})();
